import { v4 as uuidv4 } from "uuid";
export class ClockWorkAnalyticsModel {
    constructor() {
        this.teamId = uuidv4();
        this.teamName = "";
        this.clockWorkAnalyticsMembers = [];
    }
}
export default class ClockWorkAnalytics extends ClockWorkAnalyticsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
